import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { VERSION_LABEL } from '../version';

/**
 * Página pública de status da exclusão de dados (Facebook Data Deletion Callback).
 * Mostrada ao usuário após a solicitação de exclusão ser processada.
 */
export function DataDeletionStatusScreen() {
  const [searchParams] = useSearchParams();
  const confirmationCode = searchParams.get('confirmation') ?? '';

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-5 py-10">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-gray-200 p-6 sm:p-8 text-center">
        <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-4">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <h1 className="text-xl font-bold text-gray-900">Solicitação recebida</h1>
        <p className="mt-3 text-sm text-gray-600 leading-relaxed">
          Sua solicitação de exclusão de dados foi recebida e processada.
          Seus dados pessoais foram removidos do HomeStock.
        </p>

        {confirmationCode ? (
          <div className="mt-5 bg-gray-50 border border-gray-200 rounded-lg px-4 py-3">
            <p className="text-xs text-gray-500 uppercase tracking-wide">Código de confirmação</p>
            <p className="mt-1 font-mono text-sm font-bold text-gray-900 break-all">{confirmationCode}</p>
            <p className="mt-2 text-xs text-gray-500">
              Guarde este código caso precise comprovar a solicitação junto ao Facebook.
            </p>
          </div>
        ) : null}

        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-emerald-600 hover:text-emerald-700"
        >
          Voltar ao HomeStock
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
          </svg>
        </Link>
      </div>
      <p className="mt-6 text-xs text-gray-400">{VERSION_LABEL}</p>
    </div>
  );
}